<!-- @veltra/icons generated sha256:d22ba972ad80f4fd gen:8 source:src/svg/normal/location.svg -->
<script setup lang="ts">
defineOptions({ name: 'Location' })
</script>
<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
    <path
      fill="currentColor"
      d="m3.856 8.912 3.782 5.556c.174.256.55.256.724 0l3.783-5.556a5.014 5.014 0 1 0-8.29 0m6.982-5.66a4.014 4.014 0 0 1 .48 5.097L8 13.223 4.682 8.349a4.014 4.014 0 0 1 6.156-5.097M8 8.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5m0-4a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3"
    />
  </svg>
</template>
